import { BodyText, BodyTextElement, BodyTextProps } from '@farol-ds/react'
import classNames from 'classnames'
import { useContext } from 'react'

import { PriceContext } from './context'
import styles from './price-value-frequency.module.scss'

export type PriceValueFrequencyElement = BodyTextElement

export type PriceValueFrequencyProps = BodyTextProps

function PriceValueFrequency(props: PriceValueFrequencyProps) {
  const { children, className, ...rest } = props
  const classes = classNames(styles.root, className)
  const { size } = useContext(PriceContext)
  return (
    <BodyText {...rest} size={size} asChild>
      <span className={classes} {...rest}>
        {children}
      </span>
    </BodyText>
  )
}

export default PriceValueFrequency
